import { createSlice, PayloadAction } from "@reduxjs/toolkit";

import { Invitations, Member, MemberState } from "@/types/organization";

const initialState: MemberState = {
  members: [],
  invitations: [],
};

export const memberSlice = createSlice({
  name: "members",
  initialState,
  reducers: {
    addMember: (state, action: PayloadAction<Member>) => {
      const newMember: Member = {
        ...action.payload,
      };
      state.members.push(newMember);
    },

    setMembers: (state, action: PayloadAction<Member[]>) => {
      state.members = action.payload;
    },
    setInvitations: (state, action: PayloadAction<Invitations[]>) => {
      state.invitations = action.payload;
    },
    updateMember: (state, action: PayloadAction<Member>) => {
      const index = state.members.findIndex(
        (member) => member.id === action.payload.id,
      );
      if (index !== -1) {
        Object.assign(state.members[index], action.payload);
      }
    },

    deleteMember: (state, action: PayloadAction<number | string>) => {
      state.members = state.members.filter((member) => {
        if (typeof action.payload === "number") {
          return member.id !== action.payload;
        } else {
          return member.email !== action.payload;
        }
      });
    },
  },
});

export const {
  addMember,
  updateMember,
  deleteMember,
  setMembers,
  setInvitations,
} = memberSlice.actions;

export default memberSlice.reducer;
